'use client';

import TenantNotFound from '@/components/tenant/TenantNotFound';

/**
 * 404 do site público do tenant: branding + carrossel de imóveis recomendados
 * extraídos da URL quebrada (imóvel vendido/deletado, link antigo etc.).
 * Renderiza dentro do layout do tenant → TenantProvider ativo.
 */
export default function NotFound() {
  return <TenantNotFound />;
}
